import { Button } from 'antd';
import React from 'react';
import { addDatasetToScoringAlgorithm, removeDatasetToScoringAlgorithm } from '../../lib/api/aws-api';
import { DatasetSelection } from '../../types';
import useGlobal from '../../store/Store';

type Props = {
  datasetSelection: DatasetSelection;
  algorithmId: number;
};

export const DatasetRow = ({ datasetSelection, algorithmId }: Props) => {
  const [, globalActions] = useGlobal();
  const toggleDataset = async () => {
    if (datasetSelection.selected && datasetSelection.datasetToAlgorithmOverviewId) {
      // remove
      await removeDatasetToScoringAlgorithm(datasetSelection.datasetToAlgorithmOverviewId.toString());
      globalActions.doRefreshOverview();
    } else {
      // add
      await addDatasetToScoringAlgorithm(datasetSelection.dataset.id, algorithmId.toString());
      globalActions.doRefreshOverview();
    }
  };

  return (
    <div
      key={datasetSelection.dataset.id}
      className="py-2 flex justify-between items-center border-0 border-b border-solid border-gray-200">
      <span>{datasetSelection.dataset.name}</span>
      <div className="flex gap-3">
        <Button onClick={toggleDataset} danger={datasetSelection.selected ? true : false}>
          {datasetSelection.selected ? 'Remove' : 'Add'}
        </Button>
      </div>
    </div>
  );
};
